const acceptDict = {
    ".pdf": "application/pdf",
    ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".doc": "application/msword",
    ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".xls": "application/vnd.ms-excel",
    ".txt": "text/plain",
    ".jpg": "image/jpeg",
    ".jpeg": "image/jpeg",
    ".png": "image/png",
    ".gif": "image/gif",
    ".mp4": "video/mp4",
    ".mp3": "audio/mpeg",
    ".wav": "audio/wav",
    ".zip": "application/zip",
    ".rar": "application/x-rar-compressed",
    ".json": "application/json",
    ".csv": "text/csv",
    ".xml": "application/xml",
    ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ".ppt": "application/vnd.ms-powerpoint",
    ".p12": "application/x-pkcs12"
}

const docTitleDict = {
    '/login': 'DataWorkers',
    '/home/index': 'DataWorkers',
    '/Nopermission': 'DataWorkers',
    // AccountPayable
    '/AccountPayable/UtilityPayment': 'Utility Payment',
    '/AccountPayable/UtilityPaymentMonths': 'Utility Payment Months',
    '/AccountPayable/ApprovalSummary': 'Approval Summary',
    '/AccountPayable/ApprovalSummaryMonthlyTableDetail': 'Approval Summary',
    '/AccountPayable/ApprovalSummaryUtilTableDetail': 'Approval Summary',
    '/AccountPayable/ApprovalSummaryPendingTableDetail': 'Approval Summary',
    '/AccountPayable/MaintenanceContractorTableDetail': 'Approval Summary',
    '/AccountPayable/GardenerAPTableDetail': 'Approval Summary',
    '/AccountPayable/MajorProjectTableDetail': 'Approval Summary',
    '/AccountPayable/MaintenanceMonthlyWorkerDetail': 'Approval Summary',
    '/AccountPayable/MaintenanceMonthlyWorkerSubDetail': 'Approval Summary',
    '/AccountPayable/BusinessLicenseTableDetail': 'Approval Summary',
    '/AccountPayable/MaterialListAPDetail': 'Approval Summary',
    '/AccountPayable/InsuranceDetail': 'Approval Summary',
    '/AccountPayable/CheckApproval': 'Check Approval',
    '/AccountPayable/CheckApprovalDetail': 'Check Approval',
    '/AccountPayable/CheckApprovalUtilPaymentDetail': 'Check Approval',
    '/AccountPayable/CheckApprovalMaintenanceDetail': 'Check Approval',
    '/AccountPayable/CheckApprovalMainContractorDetail': 'Check Approval',
    '/AccountPayable/CAGardenerAPDetail': 'Check Approval',
    '/AccountPayable/CheckApprovalMonthlyWorkerDetail': 'Check Approval',
    '/AccountPayable/CheckApprovalBusinessLicenseDetail': 'Check Approval',
    '/AccountPayable/CAMaterialListAPDetail': 'Check Approval',
    '/AccountPayable/CheckMajorProjectTableDetail': 'Check Approval',
    '/AccountPayable/MaintenancePayContractor': 'Main.Contractor',
    '/AccountPayable/MaintenancePayPUT':"Main.Contractor",
    '/AccountPayable/CAInsuranceDetail': 'Check Approval',
    '/AccountPayable/BusinessLicense': 'Business License',
    '/AccountPayable/MajorProjectAP': 'Major Project AP',
    '/AccountPayable/MaterialListAP': 'Material List AP',
    '/AccountPayable/BankMortgageRolling': 'Bank Mortgage Rolling',
    '/AccountPayable/InsuranceSummary': 'Insurance',
    '/AccountPayable/InsurancePage': 'Insurance List',
    '/AccountPayable/InsuranceEnterPaymentPage': 'Enter Payment',
    '/AccountPayable/InsuranceEditPolicyPage': 'Edit Policy',
    '/AccountPayable/Mortgage': 'Mortgage',
    '/AccountPayable/ViewLoan': 'Mortgage',
    '/AccountPayable/ApprovalHistory': 'Approval History',
    '/AccountPayable/Vendors': 'Vendors',
    '/AccountPayable/PendingCheck': 'Pending Check',
    '/AccountPayable/GardenerAP': 'Gardener AP',
    '/AccountPayable/GardenerAPMaintenance': 'Gardener AP',
    '/AccountPayable/Insurance':'Insurance',
    // AccountReceivable
    '/AccountReceivable/CashReceived':'Cash Received',
    // Dashboard
    '/Dashboard/OperatingStatement': 'Operating Statement',
    '/Dashboard/BankBalanceSummary':'Bank Balance Summary',
    '/Dashboard/DailyDeposit':'Daily Deposit',
    '/Dashboard/GeneralLedgerReport':'General Ledger',
    '/Dashboard/OneLineCashFlowReport':'One Line Cash Flow',
    '/Dashboard/CashPositionReport':'Cash Position Report',
    '/Dashboard/Accounting8825Report':'8825',
    '/Dashboard/Vacancy':'Vacancy',
    '/Dashboard/operatingStatementMonthsReport': 'Operating Statement Trailing 12 Months Reports',
    '/Dashboard/RESReport':'RES Report',
    '/Dashboard/ResMortgage':'RES With Mortgage',
    '/Dashboard/VacancyEvictionBalanceReport':'Vacancy, Eviction & Balance Report',
    // BankReconciliation/BankRec
    '/BankReconciliation/BankRec':'BankReconciliation',
    '/BankReconciliation/Bank' :'Bank',
    '/BankReconciliation/BankRec/UTPage' :'Bank Rec Clear Tran',
    '/BankReconciliation/BankRec/UnreconciledPage':'Bank Unrec Trans',
    '/BankReconciliation/BankRec/component/BookUnreconciledPage':'Book Unrec Trans',
    '/BankReconciliation/BankRec/component/OutstandPage':'Bank Unrec Trans',
    '/BankReconciliation/BankRec/component/FundTransferPage':'Record Fund Transfe',
    '/BankReconciliation/BankRec/component/RecordCreditPage':'Record Credit',
    '/BankReconciliation/BankRec/component/RecordDebitPage':'Record Debit',
    // RecordAdjustment
    'RecordAdjustment/VoidCheck':"VoidCheck",
    'RecordAdjustment/index':'Gl Trans',
    '/RecordAdjustment/DebitExpense':'Debit Expense',
    // JobRequests
    '/JobRequests/Maintenance': 'Maintenance',
    '/JobRequests/Maintenance/PUTTable': 'Maintenance',
    '/JobRequests/MaintenanceHistory': 'Maintenance History',
    '/JobRequests/MaintenanceHistory/PUTTableHistory': 'Maintenance History',
    '/JobRequests/NonMaintenanceRequest': 'Non Maintenance Request',
    '/JobRequests/NonMaintenanceRequest/Details': 'Non Maintenance Request Details',
    '/JobRequests/NonMaintenanceRequest/Add': 'Non Maintenance Request Add',
    '/JobRequests/NonMaintenanceHistory': 'Non Maintenance History',
    '/JobRequests/NonMaintenanceHistory/Detail': 'Non Maintenance History Detail',
    '/JobRequests/MonthlyWorker': 'Monthly Worker',
    '/JobRequests/VendorClock': 'Vendor Clock',
    '/JobRequests/VendorClock/Add': 'Vendor Clock Add',
    '/JobRequests/VendorClock/Map': 'Vendor Clock Map',
    '/JobRequests/MajorProject': 'Major Project',
    '/JobRequests/MajorProjectEdit': 'Major Project Edit',
    '/JobRequests/MaterialList': 'Material List',
    // PropertyManagement
    '/PropertyManagement/Property': 'Property',
    '/PropertyManagement/Property/MapAll': 'Property Map All',
    '/PropertyManagement/Property/Map': 'Property Map',
    '/PropertyManagement/ThreeDayNotice':'Three Day Notice',
    '/PropertyManagement/Entity':'Entity',
    // UserManagment
    '/UserManagment/Account': 'Account',
    '/UserManagment/Role': 'Role',
    '/UserManagment/AppUser': 'App User',
    '/UserManagment/Menu': 'Menu',
    '/UserManagment/RoleManagement': 'Role Management',
    // Settings
    '/Settings/TypeJob': 'Type Job',
    '/Settings/HardWareStore': 'HardWare Store',
    '/Settings/EmployeesTimeAllowance':'Employees Time Allowance',
     '/Settings/TypeApLicense':'Business License Type',
     '/Settings/InsuranceType':'InsuranceType',
     '/Settings/UtilityTenantInvoice':'Utility Tenant Invoice',
    '/Settings/EmploymentTitle':'Employment Title',
    '/Settings/HolidayCalendar':'Holiday Calendar',
    '/Settings/Apliance':'Apliance',
    '/Settings/GeneralLedgerReport':'General Ledger Report',
     '/Settings/AnnualLeave':'Annual Leave',
    '/Settings/FieldRule':'Field Rule',
    '/Settings/BankByGroup':'Bank Group',
    '/Settings/VendorType':'Vendor Type',
    'Settings/GLChart':"GL Chart",
    '/Settings/GLAcctSubType':'GLAcct Sub Type',
    '/Settings/ApModuleGlAcctRange':'Ap Module GlAcct',
    '/Settings/StateCountyCity': 'StateCountyCity',
    // 特殊
    '/JobRequests/Maintenance/NewOrder': 'New Job',
    '/JobRequests/Maintenance/Details': 'Viewing Job',
    '/UserUsage/index': 'User Usage',
    // pay Roll
     '/PayRoll/MangerTimeSheet':'Manger Time Sheet',
     '/PayRoll/MangerAttendance':'Manger Attendance',
     '/PayRoll/EmployeesInformation':'Employees Information',
     '/PayRoll/ManagerWorkTime':'Manager Work Time',
     '/PayRoll/ManagerWorkTimeDetail':'Manager Work Time',
    //  report 
    '/Report/JobRequest':'Job Request',
    '/Dashboard/Delinquency':"Delinquency",
    '/Report/OperatingStatementAnalysis':'Operating Statement Analysis',

}

const checkApproveRouteDict = {
    'maintenance': '/AccountPayable/CheckApprovalMaintenanceDetail',
    'util_payment': "/AccountPayable/CheckApprovalUtilPaymentDetail",
    'major_project': "/AccountPayable/CheckMajorProjectTableDetail",
    'maintenance_contractor': "/AccountPayable/CheckApprovalMainContractorDetail",
    'gardener': "/AccountPayable/CAGardenerAPDetail",
    'maintenance_monthly_worker': "/AccountPayable/CheckApprovalMonthlyWorkerDetail",
    'businessLicense': "/AccountPayable/CheckApprovalBusinessLicenseDetail",
    'maintenance_material_ap': "/AccountPayable/CAMaterialListAPDetail",
    'new_insurance': "/AccountPayable/CAInsuranceDetail",
    'default': "/AccountPayable/CheckApprovalDetail",
}

const approvalSummaryRouteDict = {
    'maintenance': '/AccountPayable/ApprovalSummaryMonthlyTableDetail',
    'util_payment': "/AccountPayable/ApprovalSummaryUtilTableDetail",
    'major_project': "/AccountPayable/MajorProjectTableDetail",
    'maintenance_contractor': "/AccountPayable/MaintenanceContractorTableDetail",
    'gardener': "/AccountPayable/GardenerAPTableDetail",
    'maintenance_monthly_worker': "/AccountPayable/MaintenanceMonthlyWorkerDetail",
    'businessLicense': "/AccountPayable/BusinessLicenseTableDetail",
    'maintenance_material_ap': "/AccountPayable/MaterialListAPDetail",
    'new_insurance': "/AccountPayable/InsuranceDetail",
    'default': "/AccountPayable/ApprovalSummaryPendingTableDetail",
}

const majorProjectAPStatusDictFn = ({text, record, tabsKey}) => {
    const list = [
        {
            label: 'Pending',
            value: 1,
            color: 'blue'
        },
        {
            label: 'From GC', // vendor端不用改
            value: 2,
            tabsKey: 1,
            color: 'blue'
        },
        {
            label: 'From GC', // vendor端不用改
            value: 202,
            tabsKey: 1,
            color: 'blue'
        },
        {
            label: 'Ready For Check Approval',
            value: 201,
            tabsKey: 2,
            color: 'blue'
        },
        {
            label: 'Sent Check Approval',
            value: 3,
            tabsKey: 3,
            color: 'blue'
        },
        {
            label: 'PM reject',
            value: 4,
            color: 'red'
        },
        {
            label: 'Pay Reject',
            value: 5,
            tabsKey: 2,
            color: 'red'
        },
        {
            label: 'Boss reject and admin delete',
            value: 6,
            color: 'red'
        },
        {
            label: 'Boss reject and admin delete',
            value: 7,
            color: 'red'
        },
        {
            label: 'Approved to Print',
            value: 8,
            tabsKey: 3,
            color: 'green'
        },
        {
            label: 'Pending',
            value: 9,
            tabsKey: 1,
            color: 'blue'
        },
        {
            label: 'Boss reject',
            value: 10,
            color: 'red'
        },
        {
            label: 'Boss reject',
            value: 11,
            color: 'red'
        },
    ]
    let statusMatchList = []
    let statusMatchObj = {}
    if(text && record){
        const { isColor, checkNo } = record
        const colorMatch = {
            '#3c8dbc': 'blue',
            '#dd4b39': 'red',
            'green': 'green',
            '#f39c12': 'warning',
        }
        list.push({
            label: checkNo,
            value: 1001,
            color: colorMatch[record?.colorStr || '#3c8dbc']
        },
        {
          label: 'Un Set',
          value: 404,
          color: 'yellow'
        })
        const valueTemp = isColor ? 1001 : (list.some(({ value }) => value === text) ? text : 404) 
        statusMatchObj = list.find(item => item.value === valueTemp)
    } else {
        statusMatchList = list.filter(item => item?.tabsKey === tabsKey)
    }

    return {
        statusMatchList,
        statusMatchObj
    }
}


export {
    acceptDict,
    docTitleDict,
    checkApproveRouteDict,
    approvalSummaryRouteDict,
    majorProjectAPStatusDictFn
}
